"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
const HorizontalGradient = ({ startColor, endColor, textColor, onPress, title, icon, buttonStyle, ...restProps }) => {
    const gradientColors = [
        startColor || colors_1.Colors.PRIMARY_700,
        endColor || colors_1.Colors.PRIMARY_100,
    ];
    const styles = react_native_1.StyleSheet.create({
        button: {
            borderRadius: 10,
            padding: 10,
            alignItems: "center",
            minWidth: 150,
            minHeight: 56,
            justifyContent: "center",
        },
        buttonText: {
            color: textColor,
            fontSize: 16,
            // fontWeight: "bold",
        },
    });
    return ((0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPress, ...restProps, children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: gradientColors, start: { x: 0, y: 0.5 }, end: { x: 1, y: 0.5 }, style: [styles.button, buttonStyle], children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 2, justifyContent: "center", alignItems: "center", children: [icon, title && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.buttonText, children: title }))] }) }) }));
};
exports.default = HorizontalGradient;
